import { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import CONFIG from "../../config";
import MensajeAdjuntos from "./MensajeAdjuntos";
import { useFirebaseCounter } from "../../hooks/useFirebaseCounter";
import { set } from "firebase/database";
import PerfilLogo from "../usuarios/PerfilLogo";

const URL_MENSAJES = `${CONFIG.API_URL}/operarMensajes.php`;

function MensajesGrupo({ rol, userId, id_curso_grupo, tipo, setNombreGrupo, refreshKey, configuracion, setEstadoCurso }) {
    const [mensajesGrupo, setMensajesGrupo] = useState([]);
    const [participantesGrupo, setParticipantesGrupo] = useState([]);
    const chatRef = useRef(null);

    const obtenerMensajesGrupo = useCallback(() => {
        if (!id_curso_grupo) {
            setMensajesGrupo([]);
            setNombreGrupo("");
            return;
        }
        //console.log("Obteniendo mensajes para el grupo:", id_curso_grupo,"tipo:", tipo);
        //si tipo es C el id_cursoGrupo es el curso y si es G  es el id_cursoGrupo es el id del grupo tengo que avisar a la api mandando tipo
        axios.get(`${URL_MENSAJES}?id_curso_grupo=${id_curso_grupo}&tipo=${tipo}`)
            .then(res => {
                console.log("Respuesta de mensajes:", res.data);
                if (!res.data.error && Array.isArray(res.data.mensajes)) {
                    setMensajesGrupo(res.data.mensajes);
                    setNombreGrupo(res.data.mensajes.length > 0 ? res.data.mensajes[0].nombre_curso : "");
                    setEstadoCurso(res.data.mensajes.length > 0 ? res.data.mensajes[0].estado : 'Abierto');
                    // Extraer participantes únicos del grupo
                    setParticipantesGrupo(res.data.participantes || []);
                    console.log("Mensajes grupales obtenidos:", res.data.participantes);
                } else {
                    setMensajesGrupo([]);
                }
            })
            .catch(err => console.error(err));
    }, [id_curso_grupo, setNombreGrupo]);

    // Carga inicial y cuando cambia el grupo O cuando se solicita refreshKey
    useEffect(() => {
        obtenerMensajesGrupo();
    }, [obtenerMensajesGrupo, refreshKey]);

    // Escucha Firebase: ruta mensajes_grupo/curso_{id}
    useFirebaseCounter(
        id_curso_grupo ? `mensajes_grupo/curso_${id_curso_grupo}` : null,
        () => {
            // Pequeño delay para evitar condición de carrera con la inserción DB
            setTimeout(() => {
                obtenerMensajesGrupo();
            }, 180);
        }
    );

    // Auto scroll al final cuando llegan mensajes
    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [mensajesGrupo]);

    return (
    <div className="row">
       <div className="col-12 col-xl-9">
        <div
            ref={chatRef}
            className="p-3 border rounded"
            style={{
                height: "380px",
                overflowY: "auto",
                backgroundColor: "#e5ddd5",
                display: "flex",
                flexDirection: "column"
            }}
        >
            {mensajesGrupo.length > 0 ? (
                mensajesGrupo.map(mensaje => {
                    const esMio = mensaje.id_usuario === parseInt(userId, 10);

                    return (
                        <div
                            key={mensaje.id_mensaje}
                            className={`d-flex mb-3 ${
                                esMio ? "justify-content-end" : "justify-content-start"
                            }`}
                        >
                            <div className="col-12 col-md-8 col-lg-6">
                                <div
                                    className={`p-3 rounded-4 shadow-sm ${
                                        esMio ? "bg-primary text-white" : "bg-white text-dark"
                                    }`}
                                >
                                    {!esMio && (
                                        <div className="fw-bold small mb-1">
                                            <i className="fa-solid fa-user me-1"></i>
                                            {mensaje.nombre} {mensaje.apellido}
                                        </div>
                                    )}

                                       <div className="mb-2" style={{ whiteSpace: 'pre-line' }}>
                                            <i className="fa-regular fa-envelope-open me-1"></i>
                                            {mensaje.mensaje
                                                .replace(/\\r\\n/g, '\n')
                                                .replace(/\\n/g, '\n')
                                                .replace(/\\r/g, '')
                                            }
                                        </div>

                                    {mensaje.adjunto === "Si" && (
                                        <MensajeAdjuntos mensaje_id={mensaje.id_mensaje} />
                                    )}

                                    <div className="text-end small opacity-75">
                                        {mensaje.fecha}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            ) : (
                <p className="text-center text-muted">No hay mensajes en este grupo/curso.</p>
            )}
        </div>
      </div>
      <div className="col-12 col-xl-3 p-0 d-none d-xl-block">
        <h6 className="d-flex justify-content-center mt-2">
            <i className="fa-solid fa-people-group me-2"></i>
            Participantes ({participantesGrupo.length})
        </h6>
        <div
            className="p-2 border rounded"
            style={{
                height: "350px",
                backgroundColor: "#fcfcfc",
                overflowY: "auto"
            }}
        >
            {participantesGrupo.length > 0 ? (
                participantesGrupo.map(participante => (
                    <div key={participante.id_usuario} className="d-flex align-items-center mb-3 border-bottom">
                        <PerfilLogo id={participante.id} version="logo_solo" configuracion={configuracion} />
                        <div className="small ms-1 flex-grow-1 d-flex justify-content-between">
                            <span>
                                {participante.nombre} {participante.apellido}
                                {participante.id === parseInt(userId, 10) &&
                                    <span className="small ps-1">(Tú)</span>
                                }
                            </span>
                            <span className={`small border rounded p-1 ${participante.rolNombre === 'docente' ? 'text-bg-secondary' : 'text-bg-success'}`}>
                                {participante.rolNombre === 'docente' && <i className="fa-solid fa-chalkboard-user mx-1"></i>}
                                {participante.rolNombre === 'estudiante' && <i className="fa-solid fa-user-graduate mx-1"></i>}
                                {participante.rolNombre === 'participante' && <i className="fa-solid fa-user mx-1"></i>}
                            </span>
                        </div>
                    </div>
                ))
            ) : (
                <p className="text-center text-muted">
                    No hay participantes en este grupo.
                </p>
            )}
        </div>
      </div> 
      <div className="col-12 d-xl-none mt-2">
        <div className="accordion" id="participantesAccordion">
            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#participantesCollapse"
                    >
                        <i className="fa-solid fa-people-group me-2"></i>
                        Participantes ({participantesGrupo.length})
                    </button>
                </h2>
                <div
                    id="participantesCollapse"
                    className="accordion-collapse collapse"
                    data-bs-parent="#participantesAccordion"
                >
                    <div className="accordion-body p-2">
                        {participantesGrupo.length > 0 ? (
                            participantesGrupo.map(participante => (
                                <div key={participante.id_usuario} className="d-flex align-items-center mb-3 border-bottom">
                                    <PerfilLogo id={participante.id} version="logo_solo" configuracion={configuracion} />
                                    <div className="small ms-1 flex-grow-1 d-flex justify-content-between">
                                        <span>
                                            {participante.nombre} {participante.apellido}

                                            {participante.id === parseInt(userId, 10) &&
                                                <span className="small ps-1">(Tú)</span>
                                            }
                                        </span>
                                        <span className={`small border rounded p-1 ${participante.rolNombre === 'docente' ? 'text-bg-secondary' : 'text-bg-success'}`}>
                                            {participante.rolNombre === 'docente'
                                                ? <i className="fa-solid fa-chalkboard-user mx-1"></i>
                                                : <i className="fa-solid fa-user-graduate mx-1"></i>}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-muted">
                                No hay participantes en este grupo.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div> 
    </div>
    );
}

export default MensajesGrupo;